const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const MIN_BRAND_YEAR = 2024;

export interface BrandMonthOption {
  value: number;
  label: string;
}

// Month dropdown: 1-12 with month names, per the Brands tab update spec
// (docs/mockups/BRANDS-tab-update-spec.md, Section 2/6).
export const BRAND_MONTH_OPTIONS: BrandMonthOption[] = MONTH_NAMES.map((label, index) => ({
  value: index + 1,
  label,
}));

// Year dropdown: 2024 through the actual current year (not hardcoded),
// per the same spec's Section 2.
export function getBrandYearOptions(): number[] {
  const currentYear = new Date().getFullYear();
  const years: number[] = [];
  for (let year = MIN_BRAND_YEAR; year <= currentYear; year++) years.push(year);
  return years;
}

export function getDefaultBrandMonth(): number {
  return new Date().getMonth() + 1;
}

export function getDefaultBrandYear(): number {
  return new Date().getFullYear();
}

export function getBrandMonthLabel(month: number): string {
  return MONTH_NAMES[month - 1] ?? "";
}
